import { useLayoutEffect, useRef } from 'react'

import { getShellContentScrollElement } from 'shared/shell_content_scroll_registry'

/** Extra sticky chrome below the base meetings header offset (preset chip row height). */
export const MEETINGS_PRESET_TABS_BAND_CSS_VAR = '--meetings-preset-tabs-band'
/** Bottom edge of the meeting table (preset row); drives scroll sensor + scroll-margin. */
export const MEETINGS_FEED_TOP_CSS_VAR = '--meetings-feed-top'

/**
 * Publishes preset tabs row height and live feed-top (row bottom) for scroll sensor,
 * scroll-margin, and fixed controls like scroll-to-today.
 */
export const useMeetingsPresetTabsScrollBand = (enabled) => {
  const rowRef = useRef(null)

  useLayoutEffect(() => {
    if (!enabled) {
      document.documentElement.style.removeProperty(MEETINGS_PRESET_TABS_BAND_CSS_VAR)
      document.documentElement.style.removeProperty(MEETINGS_FEED_TOP_CSS_VAR)
      return undefined
    }

    const node = rowRef.current
    if (!node) return undefined

    const syncMetrics = () => {
      document.documentElement.style.setProperty(
        MEETINGS_PRESET_TABS_BAND_CSS_VAR,
        `${node.offsetHeight}px`,
      )
      const { bottom, height } = node.getBoundingClientRect()
      if (height > 0) {
        document.documentElement.style.setProperty(
          MEETINGS_FEED_TOP_CSS_VAR,
          `${Math.round(bottom)}px`,
        )
      }
    }

    syncMetrics()

    const observer = new ResizeObserver(syncMetrics)
    observer.observe(node)

    window.addEventListener('resize', syncMetrics)
    const shellScroll = getShellContentScrollElement()
    shellScroll?.addEventListener('scroll', syncMetrics, { passive: true })

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', syncMetrics)
      shellScroll?.removeEventListener('scroll', syncMetrics)
      document.documentElement.style.removeProperty(MEETINGS_PRESET_TABS_BAND_CSS_VAR)
      document.documentElement.style.removeProperty(MEETINGS_FEED_TOP_CSS_VAR)
    }
  }, [enabled])

  return rowRef
}
